(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3635],{

/***/ 326:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/360-spin-overlay.220435f7.svg","height":60,"width":60});

/***/ }),

/***/ 23043:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/play-button-overlay.67b4b5c0.svg","height":60,"width":60});

/***/ }),

/***/ 23171:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/tap-image-zoom.870cb4c5.svg","height":58,"width":224});

/***/ }),

/***/ 11812:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/zoom-close-icon.91e663a4.svg","height":50,"width":50});

/***/ }),

/***/ 5025:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/zoom-video-icon.dddeb007.svg","height":60,"width":60});

/***/ }),

/***/ 98791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const CollapsibleHeader = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "collapsible__header",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                role: "heading",
                "aria-level": "2",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "plus",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "line line-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "line line-2"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CollapsibleHeader);


/***/ }),

/***/ 75671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q8": function() { return /* binding */ THREE_SIXTY_MAIN; },
/* harmony export */   "RU": function() { return /* binding */ THREE_SIXTY_CAROUSEL_LABLE; },
/* harmony export */   "aO": function() { return /* binding */ SCENE7_SERVER_IMAGE; },
/* harmony export */   "e5": function() { return /* binding */ SCENE7_JS_URL; },
/* harmony export */   "ur": function() { return /* binding */ THREE_SIXTY_LABLE; }
/* harmony export */ });
/* unused harmony export THREE_SIXTY_FULL_SCREEN */
const SCENE7_JS_URL = "https://kohler.scene7.com/s7viewers/html5/js/";
const SCENE7_SERVER_IMAGE = "https://kohler.scene7.com/is/image/";
const THREE_SIXTY_LABLE = "360 spin";
const THREE_SIXTY_MAIN = "main";
const THREE_SIXTY_CAROUSEL_LABLE = "carousel";
const THREE_SIXTY_FULL_SCREEN = "360 spin fullscreen";


/***/ }),

/***/ 4464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getDimensionData; }
/* harmony export */ });
const getDimensionData = (dimensionData)=>{
    if (Object.keys(dimensionData).length) {
        const { ProductDimensionAttributes =[] , ProductDimensionAttributesValues =[] , ProductSpecificationAttributesValues =[]  } = dimensionData;
        var ref;
        const { Specification ="[]" , Dimension ="[]" , enable: enabled = false  } = (ref = ProductDimensionAttributes[0]) !== null && ref !== void 0 ? ref : {};
        const specification = JSON.parse(Specification);
        const dimension = JSON.parse(Dimension);
        const processedData = {
            enabled,
            dimensions: dimension === null || dimension === void 0 ? void 0 : dimension.map((d, idx)=>{
                var ref;
                return {
                    key: idx + 1,
                    label: d.label,
                    value: (ProductDimensionAttributesValues === null || ProductDimensionAttributesValues === void 0 ? void 0 : (ref = ProductDimensionAttributesValues[0]) === null || ref === void 0 ? void 0 : ref[d.pimAttribute]) || "",
                    tooltip: d.tooltip,
                    unit: d.unit
                };
            }),
            specifications: specification.length && specification[0].label.length ? specification === null || specification === void 0 ? void 0 : specification.map((s, idx)=>{
                var ref;
                var ref1;
                return {
                    key: idx + 1,
                    label: s.label,
                    value: (ProductSpecificationAttributesValues === null || ProductSpecificationAttributesValues === void 0 ? void 0 : (ref = ProductSpecificationAttributesValues[0]) === null || ref === void 0 ? void 0 : ref[s.pimAttribute]) || "",
                    tooltip: s.tooltip,
                    unit: (ref1 = s === null || s === void 0 ? void 0 : s.unit) !== null && ref1 !== void 0 ? ref1 : ""
                };
            }) : []
        };
        return processedData;
    }
    return {};
};


/***/ }),

/***/ 24474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductDetailView_StickyHead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var lib = __webpack_require__(75198);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/analytics.js
var analytics = __webpack_require__(30525);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/StickyHeader/analytics/index.js
const getAnalyticsData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { itemStatus , productStock =0 , backOrder , specialOrder  } = data;
    let analyticsAddToCart = '{"eventAction":"pdp:sticky nav:add to cart","eventName":"pdp:sticky nav:add to cart","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"add to cart","internalLinkPosition":"header","internalLinkType":"pdp:add to cart","internalLinkZoneName":"pdp:sticky nav","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    if (itemStatus === "outOfStock" || !(productStock > 0)) {
        analyticsAddToCart = JSON.stringify({
            clickInternalLinks: "true",
            eventAction: "pdp:sticky nav:notify me",
            eventMsg: "n/a",
            eventName: "pdp:sticky nav:notify me",
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "notify me",
            internalLinkPosition: "header",
            internalLinkType: "pdp:notify me",
            internalLinkURL: "n/a",
            internalLinkZoneName: "pdp:sticky nav"
        });
        if (specialOrder === "Yes" || backOrder === "Yes") {
            analyticsAddToCart = '{"eventAction":"pdp:sticky nav:add to cart","eventName":"pdp:sticky nav:add to cart","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"add to cart","internalLinkPosition":"header","internalLinkType":"pdp:add to cart","internalLinkZoneName":"pdp:sticky nav","internalLinkURL":"n/a","clickInternalLinks":"true"}';
        }
    } else if (itemStatus === "discontinued") {
        analyticsAddToCart = '{"eventAction":"pdp:find similar items","eventName":"pdp:find similar items","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"find similar items","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    } else if (itemStatus === "preOrder") {
        analyticsAddToCart = '{"eventAction":"pdp:pre order","eventName":"pdp:pre order","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"pre order","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    } else if (itemStatus === "specialOrder") {
        analyticsAddToCart = '{"eventAction":"pdp:special order","eventName":"pdp:special order","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"special order","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    }
    return analyticsAddToCart;
};

// EXTERNAL MODULE: ./components/ProductDetail/v3/StickyHeader/index.module.scss
var index_module = __webpack_require__(2819);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./utils/cart.js
var utils_cart = __webpack_require__(11763);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/StickyHeader/index.jsx
















const StickyHeader = (props)=>{
    const { staticTexts: { addToCart ="" , notifyMailCTA ="" , findSimilar ="" , preOrder ="" , specialOrder ="" , availColorCTA =""  } , productStock ="" , backOrder ="" , disableEcommerce ="" , replaceAddToCart =()=>{} , replaceAddToCartCtaLabel ="" , price =0 , onAddToCart =()=>{} , sku ="" , isComboSku ="" , customerBrandName ="" , imgUrl ="" , title ="" , color ="" , currencySign ="" , isDiscontinued ="" , isColorDiscontinued ="" , isRegionSoldOnline ="" , onAvailableColor =()=>{} , handleScroll =()=>{} , replaceAddToCartCtaLink ="" , linkNewTab ="" , description ="" , analyticData ={} , productPriceSpiderIncluded ="" , isDynamicBundle =false , disableBundleAddToCart =false  } = props || {};
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const { label , url  } = color;
    const [showBuyBoxArea, setShowBuyBoxArea] = (0,react.useState)(true);
    const itemStatus = get_default()(props, "itemStatus", "available");
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [loading, setLoading] = (0,react.useState)(false);
    const { featureFlags , globalConfig ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { pdp: { data: { primaryBundleSKU_s: primaryBundleSKUs = ""  } = {}  } = {}  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const { apiEndpoints: { stockFailureErrorMsg =""  } = {}  } = globalConfig;
    const isBundleProduct = Boolean(primaryBundleSKUs);
    const { MYSQLCONNSTR_DISABLE_ADD_CART: disableAddcart  } = featureFlags;
    let buttonText = addToCart;
    const isBackorderable = backOrder === "Yes";
    const analyticsAddToCart = getAnalyticsData({
        itemStatus,
        productStock,
        backOrder,
        specialOrder: props.specialOrder
    });
    if (itemStatus === "outOfStock" || !(productStock > 0)) {
        buttonText = notifyMailCTA;
        if (!isBundleProduct && (specialOrder === "Yes" || isBackorderable) || isDynamicBundle) {
            buttonText = addToCart;
        }
    } else if (itemStatus === "discontinued") {
        buttonText = findSimilar;
    } else if (itemStatus === "preOrder") {
        buttonText = preOrder;
    } else if (itemStatus === "specialOrder") {
        buttonText = specialOrder;
    }
    const analyticsWhereToBuy = disableEcommerce && replaceAddToCart && replaceAddToCartCtaLabel && JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "pdp:sticky nav:".concat(replaceAddToCartCtaLabel),
        eventMsg: "n/a",
        eventName: "pdp:sticky nav:".concat(replaceAddToCartCtaLabel),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(replaceAddToCartCtaLabel),
        internalLinkPosition: "header",
        internalLinkType: "pdp:".concat(replaceAddToCartCtaLabel),
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:".concat(replaceAddToCartCtaLabel)
    });
    (0,react.useEffect)(()=>{
        if (productPriceSpiderIncluded) {
            setShowBuyBoxArea(false);
        } else if (!price) {
            setShowBuyBoxArea(false);
        } else {
            setShowBuyBoxArea(true);
        }
    }, [
        productPriceSpiderIncluded,
        price
    ]);
    const onAddToCartCb = ()=>{
        setLoading(false);
    };
    const handleClick = async ()=>{
        setLoading(true);
        if (buttonText === notifyMailCTA) {
            window.scroll({
                top: 800,
                left: 0,
                behavior: "smooth"
            });
        } else if (isDynamicBundle) {
            onAddToCart(onAddToCartCb);
        } else {
            if (analyticsAddToCart && window.adobeDataLayer) {
                // handle Requirement#19 Sticky Nav Add To Cart
                const eventInfo = JSON.parse(analyticsAddToCart);
                const { adobeDataLayer: { getState  } = {}  } = window;
                const page = getState && getState("page") || {};
                if (!page.cart) {
                    page.cart = {
                        cartID: cart.id
                    };
                } else {
                    page.cart.cartID = cart.id;
                }
                const otherInfo = {};
                if (page === null || page === void 0 ? void 0 : page.productInfo) {
                    otherInfo.productInfo = page.productInfo;
                    delete page.productInfo;
                }
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo,
                    page,
                    ...otherInfo
                });
            }
            const { stock , isError =false  } = await (0,utils_cart/* getStock */.K5)(sku);
            if (isError) {
                dispatch((0,genericSlice/* showToast */.CF)({
                    isVisible: true,
                    message: stockFailureErrorMsg
                }));
                setLoading(false);
                return;
            }
            if (stock > 0 || isBackorderable) {
                onAddToCart([
                    {
                        sku,
                        quantity: 1,
                        isBundle: isComboSku,
                        backorder: isBackorderable,
                        brand: customerBrandName === null || customerBrandName === void 0 ? void 0 : customerBrandName.toLowerCase()
                    }
                ], onAddToCartCb);
            } else {
                setLoading(false);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).pdpStickyHeadWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pdp-sticky-header container-fluid",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pdp-sticky-header__details-wrap container-fluid",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pdp-sticky-header__container kf-react-plp-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: imgUrl,
                            alt: title,
                            width: 80,
                            height: 80
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdp-sticky-header__details",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pdp-sticky-header__brand-name",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pdp-sticky-header__description",
                                    children: description
                                })
                            ]
                        }),
                        itemStatus === "available" && color && label !== "Not Applicable" && url && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdp-sticky-header__color-block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-sticky-header__color",
                                    style: {
                                        backgroundImage: "url('".concat(url, "')")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pdp-sticky-header__color-label",
                                    children: label
                                })
                            ]
                        }),
                        showBuyBoxArea && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()({
                                "pdp-sticky-header__right": true,
                                "pdp-sticky-header__right--retailers": productPriceSpiderIncluded
                            }),
                            children: [
                                itemStatus !== "discontinued" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-sticky-header__price-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pdp-sticky-header__price",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            value: price,
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        })
                                    })
                                }),
                                isDiscontinued ? isColorDiscontinued && !disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "button",
                                    useDefaultClass: true,
                                    label: availColorCTA,
                                    size: "small",
                                    type: "primary",
                                    onClick: onAvailableColor
                                }) : null : isRegionSoldOnline && (productStock > 0 || specialOrder === "Yes" || backOrder === "Yes" || isDynamicBundle) && !disableEcommerce || isBundleProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    useDefaultClass: true,
                                    label: buttonText,
                                    size: "small",
                                    type: "primary",
                                    role: "button",
                                    onClick: handleClick,
                                    disabled: disableAddcart || disableBundleAddToCart,
                                    loading: loading
                                }) : isRegionSoldOnline && !disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "button",
                                    useDefaultClass: true,
                                    className: "".concat(analyticsAddToCart ? "gbh-data-layer" : ""),
                                    "data-gbh-data-layer": "".concat(analyticsAddToCart || null),
                                    "data-gbh-data-layer-custom": analyticData || null,
                                    label: buttonText,
                                    size: "small",
                                    type: "primary",
                                    onClick: handleScroll
                                }) : null,
                                replaceAddToCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: ()=>{
                                        (0,analytics/* replaceAddToCartDatalayerPush */.ME)(replaceAddToCartCtaLabel, replaceAddToCartCtaLink, analyticData);
                                        router.push(replaceAddToCartCtaLink);
                                    },
                                    useDefaultClass: true,
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": analyticsWhereToBuy,
                                    "data-gbh-data-layer-custom": analyticData,
                                    role: "button",
                                    ariaLabel: replaceAddToCartCtaLabel,
                                    label: replaceAddToCartCtaLabel,
                                    size: "small",
                                    type: "primary",
                                    to: replaceAddToCartCtaLink,
                                    target: linkNewTab ? "_blank" : "_self"
                                }) : ""
                            ]
                        })
                    ]
                })
            })
        })
    });
};
StickyHeader.defaultProps = {
    productStock: "",
    backOrder: "",
    disableEcommerce: "",
    replaceAddToCart: "",
    replaceAddToCartCtaLabel: "",
    onAddToCart: "",
    sku: "",
    isComboSku: "",
    customerBrandName: "",
    title: "",
    isDiscontinued: "",
    isColorDiscontinued: "",
    isRegionSoldOnline: "",
    onAvailableColor: "",
    handleScroll: "",
    replaceAddToCartCtaLink: "",
    linkNewTab: "",
    imgUrl: "",
    productSku: "",
    brandName: "",
    description: "",
    currencySign: "",
    price: 0,
    itemStatus: "available",
    color: {
        label: "",
        url: ""
    },
    staticTexts: {
        addToCart: "",
        notifyMailCTA: "",
        findSimilar: "",
        preOrder: "",
        specialOrder: "",
        availColorCTA: ""
    },
    isDynamicBundle: false,
    disableBundleAddToCart: false
};
/* harmony default export */ var v3_StickyHeader = (StickyHeader);

// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductDetailView/StickyHead.jsx





const StickyHead = (props)=>{
    var ref;
    const { isDiscontinued ="" , showStickyHeader ="" , stickyHeaderProps ={} , discountedPrice =0 , price =0 , staticTexts ={} , onAddToCart , isColorDiscontinued ="" , addToCartProps ={} , productOnStock ="" , sku ="" , customerFacingSKU ="" , isComboSku ="" , handleScroll , onAvailableColor ="" , isRegionSoldOnline ="" , productAnalyticsData ={} , customerBrandName ="" , replaceAddToCart ="" , disableRatings ="" , replaceAddToCartCtaLink ="" , replaceAddToCartCtaLabel ="" , linkNewTab ="" , disableEcommerce ="" , currencySign ="" , swatchUrl ="" , imagesData ={} , presetConfigObject ={} , assetAccountName ="" , productPriceSpiderIncluded ="" , isDynamicBundle =false , stickyHeaderImageURL ="" , disableBundleAddToCart =false  } = props || {};
    const [sticky, setSticky] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        onFixedToggle: ()=>setSticky(!sticky),
        className: "product-detail-page__sticky-wrapper",
        stickyClassName: "sticky sticky-pdp-page",
        children: !isDiscontinued && sticky && showStickyHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_StickyHeader, {
            ...stickyHeaderProps,
            currencySign: currencySign,
            price: discountedPrice > 0 ? discountedPrice : price,
            staticTexts: staticTexts,
            imgUrl: stickyHeaderImageURL || (0,utils/* getPresetThumbnailUrl */.BB)(swatchUrl, (ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.assetId, presetConfigObject, assetAccountName),
            onAddToCart: onAddToCart,
            isDynamicBundle: isDynamicBundle,
            disableBundleAddToCart: disableBundleAddToCart,
            isDiscontinued: isDiscontinued,
            isColorDiscontinued: isColorDiscontinued,
            specialOrder: addToCartProps.specialOrder,
            backOrder: addToCartProps.backOrder,
            productStock: productOnStock,
            sku: sku,
            customerFacingSKU: customerFacingSKU,
            isComboSku: isComboSku,
            handleScroll: handleScroll,
            onAvailableColor: ()=>onAvailableColor(),
            productPriceSpiderIncluded: productPriceSpiderIncluded,
            isRegionSoldOnline: isRegionSoldOnline,
            analyticData: productAnalyticsData.stringProductInfo,
            customerBrandName: customerBrandName,
            replaceAddToCart: replaceAddToCart,
            disableRatings: disableRatings,
            replaceAddToCartCtaLink: replaceAddToCartCtaLink,
            replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
            linkNewTab: linkNewTab,
            disableEcommerce: disableEcommerce
        })
    });
};
/* harmony default export */ var ProductDetailView_StickyHead = (StickyHead);


/***/ }),

/***/ 97463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94020);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44561);





const ProductExf = ()=>{
    const { teaserContent =[]  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_4__/* .selectPdpState */ .BY);
    return teaserContent.length ? teaserContent.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "exfpdp",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "xfpage",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    data: item,
                    count: 0
                })
            })
        }, "".concat(item["title"], "-").concat(index))) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductExf);


/***/ }),

/***/ 72943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VideoWrapper_VideoWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/youtube-play.svg
/* harmony default export */ var youtube_play = ({"src":"/_next/static/media/youtube-play.fcf5eeeb.svg","height":64,"width":64});
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
;// CONCATENATED MODULE: ./components/VideoWrapper/VideoWrapper.jsx




const waitTimeForResetingIsClick = 500;
const VideoWrapper = (props)=>{
    const { videoId ="" , thumb ="" , height ="100%" , width =0 , alt ="image" , playThumb =false , onClick =()=>{} , getVideoInfo =()=>{} , index =0 , totalPdpImages =0 , zoomEntryPoint ="" , anyliticsText =""  } = props;
    const addAnalyticsData = (type, event)=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        var ref;
        const { videoTitle ="" , title =""  } = (ref = event === null || event === void 0 ? void 0 : event.target) !== null && ref !== void 0 ? ref : {};
        const videoName = type === "fullscreen" ? title.toLowerCase() : videoTitle.toLowerCase();
        const page = getState && getState("page") || {};
        const { imageSequence  } = props;
        const eventInfo = {
            eventAction: "pdp:product details:".concat(anyliticsText ? anyliticsText : "carousel", " image click:video ").concat(type),
            eventName: "pdp:product details:".concat(anyliticsText ? anyliticsText : "carousel", "  image click:video ").concat(type),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "video ".concat(type),
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:".concat(zoomEntryPoint ? zoomEntryPoint : "video navigation"),
            internalLinkZoneName: "pdp:product details:".concat(zoomEntryPoint ? zoomEntryPoint : "view gallery"),
            internalLinkURL: "n/a",
            videoId,
            clickInternalLinks: "true",
            ...imageSequence && {
                imageSequence
            },
            videoName,
            imageSequence: "".concat(index, "_").concat(totalPdpImages)
        };
        const { productInfo  } = page;
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            productInfo
        });
    };
    const youtubePlayerPayload = {
        height,
        width,
        videoId,
        playerVars: {
            rel: 0,
            frameBorder: 0,
            allowFullScreen: true,
            autoPlay: 1
        }
    };
    const videoFullScreenCallback = (event)=>{
        if (window.isClick === true) {
            return;
        }
        window.isClick = true;
        setTimeout(()=>{
            delete window.isClick;
        }, waitTimeForResetingIsClick);
        if (document.webkitIsFullScreen || document.mozFullScreen || document.fullScreen) {
            if (event.target.tagName === "IFRAME") {
                addAnalyticsData("fullscreen", event);
            }
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("fullscreenchange", videoFullScreenCallback);
        document.addEventListener("webkitfullscreenchange", videoFullScreenCallback);
    }, []);
    const onReady = (e)=>{
        getVideoInfo(e.target, index, videoId);
    };
    return thumb || playThumb ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                role: "button",
                onClick: ()=>playThumb && onClick(videoId),
                src: "https://i.ytimg.com/vi/".concat(videoId, "/").concat(playThumb ? "mqdefault" : "default", ".jpg"),
                alt: alt,
                tabIndex: 0,
                className: "img-fluid"
            }),
            playThumb && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: youtube_play === null || youtube_play === void 0 ? void 0 : youtube_play.src,
                onClick: ()=>onClick(videoId),
                className: "img-play-button",
                alt: alt
            }),
            " "
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
        videoId: videoId,
        opts: youtubePlayerPayload,
        onPlay: (e)=>addAnalyticsData("play", e),
        onEnd: (e)=>addAnalyticsData("complete", e),
        className: "pdp-image-reel__image-list pdp-image-reel__modal-image",
        onReady: onReady
    });
};
/* harmony default export */ var VideoWrapper_VideoWrapper = (VideoWrapper);


/***/ }),

/***/ 20812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);







const NextHead = (props)=>{
    var ref, ref1, ref2, ref3;
    const { fullUrl ="" , psKey ="" , psCountry ="" , psLanguage ="" , metaLanguage ="" , pdpData: { ProductBrandName_s: productName = "" , productName_s: partsName = "" , // ProductDescriptionProductShort_s: productDescription = "",
    "Color.SKU.Details_ss": skuDetails = [] , productIsInStock_b: available = true , masterVariantDataResponse: variants = [] , productName_s: productFullName = "" , metaDescription_s: productMetaDescription = "" , productRegionAllVariantDiscontinued_b: allVariantDiscontinued = false , RegionOnBackOrder_s: backorder = ""  } = {} , pdpData ={} , reviewStatsData ={} , fullReviewData ={} , initialImageFullUrl ="" , isPart =false , skuId ="" , siteName ="" , isBundleProduct =false , persona ="GST" , config ={} , isProductExcludeFromPaidAdvertising =false  } = props;
    const { internationalization: { currencyCode ="USD"  } = {}  } = config;
    var ref4;
    const selectedSkuDetails = (ref4 = skuDetails === null || skuDetails === void 0 ? void 0 : skuDetails.find((item)=>item.includes(skuId))) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    const selectSkuList = (ref5 = selectedSkuDetails === null || selectedSkuDetails === void 0 ? void 0 : selectedSkuDetails.split("|")) !== null && ref5 !== void 0 ? ref5 : [];
    var ref6;
    const selectedSku = (ref6 = selectSkuList[selectSkuList.length - 1]) !== null && ref6 !== void 0 ? ref6 : "";
    const getVariantImage = (variantImages, tmpSkuId)=>{
        let initialImgUrl = "";
        let initialImageFullUrl = "";
        let variantImageLabels = [];
        let variantImageURLs = [];
        if (variantImages === null || variantImages === void 0 ? void 0 : variantImages.length) {
            const selVarImageUrls = [];
            const selVarImageLabels = [];
            variantImages.forEach((img)=>{
                const imgDetail = img.split("|");
                if (tmpSkuId === imgDetail[0]) {
                    var ref;
                    selVarImageLabels.push((ref = imgDetail[4]) !== null && ref !== void 0 ? ref : "");
                    selVarImageUrls.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : _constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
                } else if (!variants.find((v)=>v === imgDetail[0])) {
                    var ref1;
                    variantImageLabels.push((ref1 = imgDetail[4]) !== null && ref1 !== void 0 ? ref1 : "");
                    variantImageURLs.push(imgDetail[imgDetail.length - 1] ? imgDetail[imgDetail.length - 1] : _constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
                }
            });
            variantImageLabels = [
                ...selVarImageLabels,
                ...variantImageLabels
            ];
            variantImageURLs = [
                ...selVarImageUrls,
                ...variantImageURLs
            ];
            if (variantImageURLs.length < 1) {
                variantImageLabels.push(tmpSkuId);
                variantImageURLs.push(_constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
            }
        } else {
            variantImageLabels.push(tmpSkuId);
            variantImageURLs.push(_constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL);
        }
        const assetIdArray = variantImageURLs ? variantImageURLs[0].split("PAWEB/") : [
            ""
        ];
        initialImgUrl = assetIdArray.length > 1 ? assetIdArray[1] : "";
        var ref;
        initialImageFullUrl = (ref = variantImageURLs.find((image)=>image.includes(initialImgUrl))) !== null && ref !== void 0 ? ref : "";
        return initialImageFullUrl;
    };
    const getVariantsSchema = ()=>{
        let variantsSchema = [];
        if (variants.length > 1) {
            variantsSchema = variants.map((variant)=>{
                var ref;
                const skuId = (ref = variant === null || variant === void 0 ? void 0 : variant.sku_s) !== null && ref !== void 0 ? ref : "";
                var ref1;
                const selectedSkuDetails = (ref1 = skuDetails === null || skuDetails === void 0 ? void 0 : skuDetails.find((item)=>item.includes(skuId))) !== null && ref1 !== void 0 ? ref1 : "";
                var ref2;
                const selectSkuList = (ref2 = selectedSkuDetails === null || selectedSkuDetails === void 0 ? void 0 : selectedSkuDetails.split("|")) !== null && ref2 !== void 0 ? ref2 : [];
                var ref3;
                const selectedSku = (ref3 = selectSkuList[selectSkuList.length - 1]) !== null && ref3 !== void 0 ? ref3 : "";
                var ref4, ref5, ref6, ref7, ref8, ref9;
                return {
                    "@type": "Product",
                    sku: selectedSku,
                    gtin: (ref4 = variant === null || variant === void 0 ? void 0 : variant.SKUUPCCode_s) !== null && ref4 !== void 0 ? ref4 : "",
                    image: getVariantImage(variant["productImages.labelWithUrl_ss"], variant.sku_s),
                    name: (ref5 = variant === null || variant === void 0 ? void 0 : variant.productName_s) !== null && ref5 !== void 0 ? ref5 : "",
                    description: (ref6 = variant === null || variant === void 0 ? void 0 : variant.metaDescription_s) !== null && ref6 !== void 0 ? ref6 : "",
                    color: (ref7 = variant === null || variant === void 0 ? void 0 : variant.ColorFinish_s) !== null && ref7 !== void 0 ? ref7 : "",
                    offers: {
                        "@type": "Offer",
                        url: "".concat(fullUrl, "?skuId=").concat((ref8 = variant === null || variant === void 0 ? void 0 : variant.sku_s) !== null && ref8 !== void 0 ? ref8 : ""),
                        priceCurrency: currencyCode,
                        price: (ref9 = variant === null || variant === void 0 ? void 0 : variant["priceList.".concat(persona, ".finalPrice_d")]) !== null && ref9 !== void 0 ? ref9 : 0,
                        itemCondition: "https://schema.org/NewCondition",
                        availability: variant.productIsInStock_b ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
                    }
                };
            });
        }
        return variantsSchema;
    };
    const getSkuWithoutColorFinsih = function() {
        let skuId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return skuId.substring(0, skuId.lastIndexOf("-"));
    };
    const getReviewData = (fullReviewData)=>{
        if (!fullReviewData || Object.keys(fullReviewData).length === 0) {
            return {};
        }
        return fullReviewData === null || fullReviewData === void 0 ? void 0 : fullReviewData.map((review)=>{
            return {
                "@type": "Review",
                author: {
                    "@type": "Person",
                    name: review === null || review === void 0 ? void 0 : review.UserNickname
                },
                datePublished: review === null || review === void 0 ? void 0 : review.LastModificationTime,
                headline: review === null || review === void 0 ? void 0 : review.Title,
                reviewBody: review === null || review === void 0 ? void 0 : review.ReviewText,
                reviewRating: {
                    "@type": "Rating",
                    ratingValue: review === null || review === void 0 ? void 0 : review.Rating,
                    bestRating: review === null || review === void 0 ? void 0 : review.RatingRange
                }
            };
        });
    };
    const getReviewStatsData = (reviewStatsData)=>{
        if (!reviewStatsData || Object.keys(reviewStatsData).length === 0) {
            return {};
        }
        return {
            "@type": "AggregateRating",
            itemReviewed: {
                "@type": "IndividualProduct",
                name: isPart ? partsName : isBundleProduct ? partsName : productFullName
            },
            ratingValue: reviewStatsData === null || reviewStatsData === void 0 ? void 0 : reviewStatsData.AverageOverallRating,
            reviewCount: reviewStatsData === null || reviewStatsData === void 0 ? void 0 : reviewStatsData.TotalReviewCount,
            bestRating: reviewStatsData === null || reviewStatsData === void 0 ? void 0 : reviewStatsData.OverallRatingRange
        };
    };
    var ref7, ref8, ref9;
    const productSchema = variants.length > 1 ? [
        {
            "@context": "https://schema.org",
            "@type": "ProductGroup",
            "@id": fullUrl,
            url: fullUrl,
            additionalType: isPart ? "Service Part" : "",
            name: isPart ? partsName : isBundleProduct ? partsName : productFullName,
            image: initialImageFullUrl,
            description: isBundleProduct ? partsName : productMetaDescription,
            sku: getSkuWithoutColorFinsih(isBundleProduct ? skuId : selectedSku),
            gtin: (ref7 = (ref = variants === null || variants === void 0 ? void 0 : variants.filter((variant)=>variant.masterVariant_b)) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.SKUUPCCode_s) !== null && ref7 !== void 0 ? ref7 : "",
            brand: {
                "@type": "Brand",
                name: siteName
            },
            productGroupID: getSkuWithoutColorFinsih(isBundleProduct ? skuId : selectedSku),
            variesBy: [
                "https://schema.org/color"
            ],
            aggregateRating: getReviewStatsData(reviewStatsData),
            review: getReviewData(fullReviewData),
            hasVariant: getVariantsSchema()
        }
    ] : {
        "@context": "https://schema.org",
        "@type": "Product",
        "@id": fullUrl,
        url: fullUrl,
        additionalType: isPart ? "Service Part" : "",
        name: isPart ? partsName : isBundleProduct ? partsName : productFullName,
        image: initialImageFullUrl,
        description: isBundleProduct ? partsName : productMetaDescription,
        sku: isBundleProduct ? skuId : selectedSku,
        gtin: (ref8 = (ref2 = variants === null || variants === void 0 ? void 0 : variants.filter((variant)=>variant.masterVariant_b)) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.SKUUPCCode_s) !== null && ref8 !== void 0 ? ref8 : "",
        brand: {
            "@type": "Brand",
            name: siteName
        },
        offers: {
            "@type": "Offer",
            price: (ref9 = pdpData === null || pdpData === void 0 ? void 0 : pdpData["priceList.".concat(persona, ".finalPrice_d")]) !== null && ref9 !== void 0 ? ref9 : 0,
            priceCurrency: currencyCode,
            availability: available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
            itemCondition: "http://schema.org/NewCondition"
        },
        aggregateRating: getReviewStatsData(reviewStatsData),
        review: getReviewData(fullReviewData)
    };
    let productPrice = 0;
    if (pdpData === null || pdpData === void 0 ? void 0 : pdpData["priceList.".concat(persona, ".finalPrice_d")]) {
        productPrice = parseFloat(pdpData === null || pdpData === void 0 ? void 0 : pdpData["priceList.".concat(persona, ".finalPrice_d")]).toFixed(2);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "Kohler US Plumbing Bathroom Kitchen"
            }),
            fullUrl.includes(_constants__WEBPACK_IMPORTED_MODULE_4__.FAQ_PAGE_DATA_URL) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }) : "",
            isProductExcludeFromPaidAdvertising ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : null,
            productPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:price:amount",
                content: productPrice
            }) : null,
            productPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:price:currency",
                content: currencyCode || "USD"
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:availability",
                content: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getProductStatus */ .AEk)(allVariantDiscontinued, backorder, available)
            }),
            metaLanguage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: metaLanguage === null || metaLanguage === void 0 ? void 0 : metaLanguage.toLocaleLowerCase()
            }) : null,
            fullUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: fullUrl
            }) : null,
            psKey ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-key",
                content: psKey
            }) : null,
            psCountry ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-country",
                content: psCountry
            }) : null,
            psLanguage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "ps-language",
                content: psLanguage
            }) : null,
            productName || partsName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(JSON.stringify(productSchema))
                }
            }, "structured-data") : null
        ]
    });
};
NextHead.propTypes = {
    reviewStatsData: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    fullReviewData: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object)
};
/* harmony default export */ __webpack_exports__["Z"] = (NextHead);


/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67166);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11763);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2595);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);









const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart , isCartLoading  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        let timeoutId;
        if (!isSsr) {
            timeoutId = setTimeout(()=>{
                if (!accessToken || !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)()) {
                    dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .getOktaToken */ .cs)("guest"));
                }
            }, 5000);
        }
        // eslint-disable-next-line no-extra-semi
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        accessToken,
        isSsr
    ]);
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            if (!isCartLoading) {
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                    if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getCurrency */ .zC$)().then((currency)=>{
                            const cartPayload = {
                                currency: currency,
                                taxMode: "ExternalAmount"
                            };
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                            });
                        });
                    } else {
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                    }
                });
            }
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 2819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pdpStickyHeadWrapper":"StickyHeader_pdpStickyHeadWrapper__IJA5F"};

/***/ }),

/***/ 96724:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"Accordion_accordionWrapper__vZrfq"};

/***/ })

}]);